import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Tag from '../../../components/shared/Tag';
import YearFilterViewModel from './viewModel';
import {
  ArrowButtonNext,
  ArrowButtonPrev,
  ChipWrapper,
  Container,
  PlainRow,
  SliderProvider,
  Track,
  Viewport
} from './styled';

interface Props {
  years: string[];
  selectedYear: string | null;
  onSelectYear: (year: string) => void;
}

export default function YearFilter({ years, selectedYear, onSelectYear }: Props) {
  const { fits, containerRef, firstChipRef, windowWidth, offset, next, prev, canGoPrev, canGoNext } =
    YearFilterViewModel({ years, selectedYear });

  const renderTag = (year: string, index: number) => (
    <ChipWrapper key={year} ref={index === 0 ? firstChipRef : undefined}>
      <Tag text={year} active={selectedYear === year} onClick={() => onSelectYear(year)} />
    </ChipWrapper>
  );

  return (
    <Container ref={containerRef}>
      {fits ? (
        <PlainRow>{years.map((year, index) => renderTag(year, index))}</PlainRow>
      ) : (
        <SliderProvider>
          <ArrowButtonPrev onClick={prev} disabled={!canGoPrev} disableRipple>
            <ArrowBackIcon />
          </ArrowButtonPrev>
          <Viewport width={windowWidth}>
            <Track offset={offset}>{years.map((year, index) => renderTag(year, index))}</Track>
          </Viewport>
          <ArrowButtonNext onClick={next} disabled={!canGoNext} disableRipple>
            <ArrowForwardIcon />
          </ArrowButtonNext>
        </SliderProvider>
      )}
    </Container>
  );
}
